import GlowBackground from '@/components/site/GlowBackground';
import SectionHeader from '@/components/site/SectionHeader';

export function Privacy() {
  return (
    <LegalShell title="Privacy Policy (POPIA)" eyebrow="Legal · POPIA compliant" testId="privacy-page">
      <p>Wrongfully Arrested SA respects your privacy. This policy explains what personal information we collect through this website, how we use it, and the rights available to you under the Protection of Personal Information Act 4 of 2013 (POPIA).</p>
      <h3>Information we collect</h3>
      <p>Details you provide in the claim calculator or contact form (name, phone, email, and information about your matter) and standard technical information (approximate IP, device, and page-view data). We do not collect information from persons under 18.</p>
      <h3>Purpose &amp; lawful basis</h3>
      <p>We process your information to assess your enquiry, connect you with a South African attorney, respond to you, and improve our services. Our lawful basis is your consent when you complete our forms.</p>
      <h3>Sharing</h3>
      <p>Your details are shared only with the attorney(s) reviewing your matter under a duty of confidentiality. We do not sell your data. We use processors such as our hosting provider and Resend for email delivery — all bound by data-processing terms.</p>
      <h3>Storage &amp; security</h3>
      <p>Information is stored in a hardened database with restricted access, TLS in transit, and administrative controls. Rate limiting, honeypots and input validation protect against abuse.</p>
      <h3>Retention</h3>
      <p>We retain enquiry details for as long as necessary to progress your matter and to comply with legal obligations. You may request deletion at any time (see Your rights).</p>
      <h3>Your rights under POPIA</h3>
      <p>You may request access to, correction of, or deletion of your personal information; object to certain processing; withdraw consent; and lodge a complaint with the Information Regulator of South Africa.</p>
      <h3>Information Officer / contact</h3>
      <p>For any privacy request, email <a className="text-[#39A8FF]" href="mailto:help@myarrestclaim.com">help@myarrestclaim.com</a>.</p>
    </LegalShell>
  );
}

export function Terms() {
  return (
    <LegalShell title="Terms of Use" eyebrow="Legal" testId="terms-page">
      <p>By accessing this website you agree to these terms. If you do not agree, please do not use the site.</p>
      <h3>No legal advice</h3>
      <p>All content on this website is general educational information only and does not constitute legal advice. No attorney-client relationship is created by using this site or submitting an enquiry. A relationship arises only once a written mandate is signed with a qualified South African attorney.</p>
      <h3>Accuracy</h3>
      <p>We take reasonable care in producing this content but do not warrant that all information is complete, current or free from error. South African law evolves; rely on advice specific to your matter.</p>
      <h3>Intellectual property</h3>
      <p>All content, trademarks and branding on this site are owned by or licensed to Wrongfully Arrested SA and may not be reproduced without permission.</p>
      <h3>Prohibited use</h3>
      <p>Do not use this website to submit false information, to harass, or to attempt unauthorised access. Automated submissions are blocked.</p>
      <h3>Limitation of liability</h3>
      <p>To the extent permitted by law, we exclude liability for any loss arising from your use of this website. Nothing limits liability that cannot be excluded by law.</p>
      <h3>Governing law &amp; jurisdiction</h3>
      <p>These terms are governed by the laws of the Republic of South Africa. The South African courts have exclusive jurisdiction.</p>
    </LegalShell>
  );
}

export function Disclaimer() {
  return (
    <LegalShell title="Disclaimer" eyebrow="Legal" testId="disclaimer-page">
      <p><strong>Important:</strong> the information on this website is <em>general legal information only</em>. It is not legal advice.</p>
      <h3>No attorney-client relationship</h3>
      <p>Viewing this website, submitting the claim calculator, or otherwise contacting us does not by itself create an attorney-client relationship. Such a relationship arises only once a written mandate has been signed with a South African attorney.</p>
      <h3>Every case is different</h3>
      <p>Every matter depends on its own facts and the applicable law, including the Constitution, the Criminal Procedure Act 51 of 1977, the Prescription Act 68 of 1969, the Institution of Legal Proceedings Against Certain Organs of State Act 40 of 2002, and the leading authorities of the Constitutional Court and Supreme Court of Appeal.</p>
      <h3>Assessment</h3>
      <p>Any assessment through our online calculator is preliminary and indicative only. It does not guarantee that a claim exists, that it will succeed, or that any particular quantum will be awarded.</p>
      <h3>Prescription and notices</h3>
      <p>Civil claims are typically subject to strict notice requirements and prescription periods. Failure to comply may permanently defeat a claim. Do not delay in seeking advice.</p>
      <h3>Advertising principles</h3>
      <p>This website aims to comply with the Legal Practice Council&apos;s Code of Conduct and general South African advertising standards. No guarantee of outcome is intended or should be inferred.</p>
    </LegalShell>
  );
}

function LegalShell({ title, eyebrow, testId, children }) {
  return (
    <div className="relative pt-28 md:pt-36 pb-16" data-testid={testId}>
      <div className="absolute inset-0 pointer-events-none"><GlowBackground /></div>
      <div className="relative mx-auto max-w-3xl px-5 md:px-8">
        <SectionHeader eyebrow={eyebrow} title={title} />
        <div className="mt-12 prose prose-invert max-w-none font-inter text-white/75 [&_h3]:font-poppins [&_h3]:text-white [&_h3]:mt-8 [&_h3]:mb-3 [&_h3]:text-xl [&_p]:leading-relaxed [&_p]:mt-3">
          {children}
        </div>
      </div>
    </div>
  );
}
